require('roc-slot/spingames');
require('roc-slot/common/feature-freespin');

require('./js/konami_fallback.js');
require('./js/indicators.js');

require('./css/game.css');
require('./css/hdassets.css');
require('./css/mobileassets.css');

$.ready(function () {
    game.dimensions.width = 1740;
    game.dimensions.height = 1080;

    if (game.panel.type === 'desktop') {
        game.panel.buildHelp(9);
    } else {
        game.panel.buildHelp(8);
    }


    game.sounds.loadSounds({
        _base: base,
        konami_bell: require('./sounds/FeatureTrigger.mp3'),
        bell: require('./sounds/FeatureTrigger.mp3'),
        trigger: require('./sounds/bell.mp3'),
        drop: {
            '0': [null, null, null, null, null],
            '12': [require('./sounds/drop/12/ScatterOrchHit01.mp3'), require('./sounds/drop/12/ScatterOrchHit02.mp3'), require('./sounds/drop/12/ScatterOrchHit03.mp3'), require('./sounds/drop/12/ScatterOrchHit04.mp3'), require('./sounds/drop/12/ScatterOrchHit05.mp3')],
        },
        reel: [require('./sounds/reel/reel.mp3'), require('./sounds/reel/reel.mp3'), require('./sounds/reel/reel.mp3'), require('./sounds/reel/reel.mp3'), require('./sounds/reel/reel.mp3')],
        // reel_start: require('./sounds/reel_start.mp3'),
        reel_stop: require('./sounds/reel_stop.mp3'),
        buttons: {
            denoms: {
                denom_0: require('./sounds/buttons/denoms/denom-12.mp3'),
                denom_1: require('./sounds/buttons/denoms/denom-11.mp3'),
                denom_2: require('./sounds/buttons/denoms/denom-10.mp3'),
                denom_3: require('./sounds/buttons/denoms/denom-9.mp3'),
                denom_4: require('./sounds/buttons/denoms/denom-8.mp3'),
                denom_5: require('./sounds/buttons/denoms/denom-7.mp3'),
                denom_6: require('./sounds/buttons/denoms/denom-6.mp3'),
            },
            coins: {
                bet_0: require('./sounds/buttons/coins/bet-3.mp3'),
                bet_1: require('./sounds/buttons/coins/bet-2.mp3'),
                bet_2: require('./sounds/buttons/coins/bet-1.mp3'),
                bet_3: require('./sounds/buttons/coins/bet.mp3'),
                bet_4: require('./sounds/buttons/coins/bet+1.mp3'),
                bet_5: require('./sounds/buttons/coins/bet+2.mp3'),
                bet_6: require('./sounds/buttons/coins/bet+3.mp3'),
                bet_7: require('./sounds/buttons/coins/bet+4.mp3'),
                bet_8: require('./sounds/buttons/coins/bet+5.mp3'),
            },
            max: require('./sounds/buttons/max_bet.mp3'),
            sound: require('./sounds/buttons/volume.mp3'),
            help: require('./sounds/buttons/open.mp3'),
            close: require('./sounds/buttons/close.mp3'),
            next: require('./sounds/buttons/next.mp3'),
            prev: require('./sounds/buttons/prev.mp3'),
        },
        five_win: require('./sounds/5win.mp3'),
        freespin: {
            // default intro sound has bad timing for this title, used in freespin init
            smallTrigger: require('./sounds/freespin/FeatureTriggerShort.mp3'),
        },
        latch: require('./sounds/latch.mp3'),
        win: {
            intro1: require('./sounds/win/intro1.mp3'),
            intro2: require('./sounds/win/intro2.mp3'),
            win_1: require('./sounds/win/Level1_Hit01s.mp3'),
            win_2: require('./sounds/win/Level2_Hit06s.mp3'),
            win_3: require('./sounds/win/Level3_Hit10s.mp3'),
            bigwin_1: require('./sounds/win/Level4_Hit12s.mp3'),
            bigwin_2: require('./sounds/win/Level5_Hit17s.mp3'),
            bigwin_3: require('./sounds/win/Level6_Hit24s.mp3'),
        },
    });

    let frameAnimations = $.div("frame-animations");
    frameAnimations.addClass('hide').prependTo(game.pays);

    let message = $.div().addClass('false-messages').appendTo(game.pays);

    let actionLogo = $.div('action-logo');
    actionLogo.appendTo(game.container);

    let exclusive_pays = false;
    let maxWinLength = 0;
    let win_5s;
    let symbolWidth;
    let stackWidth;
    let fiveWinSymbolWidth;

    game.fire_holder = $.div('fireworks').appendTo(game.container);
    game.celebrationContainer = $.div('').addClass('div-crop').appendTo(game.fire_holder);
    game.celebration = $.div('celebration').addClass('').appendTo(game.celebrationContainer);

    game.specials = {
        12: {
            reels: [1, 2, 3], needs: 3, anticipate: false
        }
    };

    let freespin = game.features.freespin = game.generateFreespin({
        symbol: 12,
        introTime: 2500,
        noAutomatedSounds: true,
        outroTime: 1,
        triggerTime: 5000,
        banners: 1
    });

    freespin.dimensions = {
        width: 1920,
        height: 1222,
        font: 32,
    };

    let bubbles = 0;
    let recallFinish = false;
    let retriggeredDisplay = false;

    game.panel.dialog.pager.bubbles.on('click', function () {
        if (bubbles > game.panel.dialog._page) {
            game.sounds.play(['buttons', 'prev']);
            bubbles = game.panel.dialog._page;
        }
        else if (bubbles < game.panel.dialog._page) {
            game.sounds.play(['buttons', 'next']);
            bubbles = game.panel.dialog._page;
        }
    });

    // Help screen close
    game.panel.dialog.pager.exit.on('click', function () {
        game.sounds.play(['buttons', 'close']);
        bubbles = 0;
    });

    // Help screen right arrow click
    game.panel.dialog.pager.right.on('click', function () {
        game.sounds.play(['buttons', 'next']);
        bubbles = game.panel.dialog._page;
    });

    // Help screen left arrow click
    game.panel.dialog.pager.left.on('click', function () {
        game.sounds.play(['buttons', 'prev']);
        bubbles = game.panel.dialog._page;
    });

    game.on('scale', function () {
        for (let row in game.frame.reels) {
            game.animationResize(game.frame.reels[row].tall);
            game.animationResize(game.frame.reels[row].tall.inner);
            game.animationResize(frameAnimations.reels[row]);
        }
    });

    game.pays.on('updateScatter', function (e) {

    });

    game.on('ui', function (e) {

        for (let row in game.frame.reels) {
            game.spindle.reels[row].window.tall = $.div('tall').appendTo(game.spindle.reels[row].window);
            game.frame.reels[row].tall = $.div('tall').appendTo(game.frame.reels[row]);
            game.frame.reels[row].tall.inner = $.div().appendTo(game.frame.reels[row].tall);
            game.animationResize(game.frame.reels[row].tall);
            game.animationResize(game.frame.reels[row].tall.inner);
        }

        frameAnimations.reels = [];
        for (let i = 0; i < 5; i++) {
            frameAnimations.reels[i] = $.div().addClass("animation animation-" + i).appendTo(frameAnimations);
        }
    });

    game.on('recall_action', function (e) {

        let response = e.detail.action.response;

        if (game.inRecall) {
            game.panel.disable("lock");
        }

        if (!response.matrix) {
            return;
        }

        this.spindle.attr('class', 's' + this.last.replace);

        setWilds(response.matrix);
    });

    game.on('ready', function () {
        setTimeout(function () {
            if (!game.sounds.fallback) {
                game.sounds.sounds.bell = null;
            }
        }, 15);

        if (!game.last.matrix || game.feature.active) {
            return;
        }

        if (recallFinish) {
            game.last.recovered = true;
            game.last.doubleRollup = false;
        }

        setWilds();
    });
    game.on('spin_ready', function (e) {
        setWilds();
        findMaxWinLength(game.last.lines.pays);

    });

    game.spindle.on('spin', function () {

        retriggeredDisplay = false;

        for (let reel = 0; reel < game.frame.reels.length; reel++) {
            game.spindle.reels[reel].window.tall.pos = null;
        }

        if (game.feature.active) {

            for (let reel = 0; reel < game.frame.reels.length; reel++) {

                if (frameAnimations.reels[reel].shifted === true) {
                    overrideStack(reel);
                    removeReelStacks(reel);
                    frameAnimations.reels[reel].shifted = false;
                }
            }
        }
    });

    game.on('spin_init', function () {
        this.spindle.attr('class', 's' + this.last.replace);

        if (game.fire_holder.hasClass('animate')) {
            game.celebration.removeClass('animate');
            game.fire_holder.removeClass('animate');

        }

        for (let col = 0; col < game.config.reels; col++) {
            let rowLength = game.config.rows;

            for (let row = 0; row < rowLength; row++) {
                let offsetWidth = game.frame.reels[col].symbols[row].el.offsetWidth;

                // let offsetHeight = game.frame.reels[col].symbols[row].el.offsetHeight;

                if (typeof symbolWidth !== 'undefined' && offsetWidth < symbolWidth) {
                    game.frame.reels[col].symbols[row].css("width", symbolWidth);
                    offsetWidth = symbolWidth;
                }
                symbolWidth = offsetWidth;
                if (game.last.matrix[col][row] === 12 && game.last.scatters.pays) {
                    game.frame.reels[col].symbols[row].css("width", offsetWidth - 1);
                }

            }

        }
    });

    game.on('spin_pre_done', function () {
        if (!game.feature.active && !game.last.introShown && game.last.scatters.counts[12] > 2 && !recallFinish) {
            game.last.introShown = true;
            game.last.delayBonus = true;
            showBonusIntro(3000);
        } else if (game.feature.active && game.last.scatters.counts[12] > 2 && !retriggeredDisplay) {
            showRetriggerBanner(2000);
        } else if (game.feature.active && game.last.shifted && !game.last.shiftDone) {
            nudgeReel();
        } else if (lookForFiveWin(true) && !game.last.fiveWinDisplayed) {
            game.last.delayBonus = true;
            displayFiveWin(3000);
        } else if (game.feature.active && game.last.shifted && checkAnimate() && !game.last.animateReel) {
            animateWildStack(250);
        } else {
            decideFireworks();
        }
    });

    game.on('round_complete', function () {
        game.last.fiveWinDisplayed = true;
        game.retriggeredFreespins = false;
        if (game.fire_holder.hasClass('animate')) {
            game.fire_holder.removeClass('animate');
            game.celebration.removeClass('animate');
        }

    });

    freespin.on('init', function () {
        game.features.freespin.play.message.html('PRESS TO START');
        game.panel.show(true);
        freespin.spins.set(game.last.spins);
    });

    freespin.on('play', function () {

        if (game.fire_holder.hasClass('animate')) {
            game.celebration.removeClass('animate');
            game.fire_holder.removeClass('animate');
        }

    });

    freespin.on('spin', function () {

        if (game.inRecall) {
            game.panel.disable("lock");
        }
    });

    freespin.on('begin', function () {
        game.last.delayWin = true;

    });

    freespin.on('finish', function () {

        for (let reel = 0; reel < game.frame.reels.length; reel++) {
            removeReelStacks(reel);
        }

        game.messaging.show('logo');

        if (game.autoplay.isActive()) {
            setTimeout(function () {
                game.play();
            }, 2000);
        }

        game.panel.setCredits(game.last.credits);
    });

    game.panel.disableBigWins = function (durations) {
        this.bigwin.celebrations = {};

        for (let i = 0; i < this.bigwin.levels.length; i++) {
            this.bigwin.levels[i] = [this.bigwin.levels[i][this.bigwin.levels[i].length - 1]];

            if (this.bigwin.levels[i][0].duration) {
                this.bigwin.levels[i][0].duration = undefined;
                delete this.bigwin.levels[i][0].duration;
            }

            if (durations && durations[i]) {
                this.bigwin.levels[i][0].duration = durations[i];
            }

            if (this.bigwin.levels[i][0].celebration) {
                this.bigwin.levels[i][0].celebration = undefined;
                delete this.bigwin.levels[i][0].celebration;
            }
        }
    };

    game.panel.disableBigWins([1, 2, 3, 5, 12, 15]);

    function decideFireworks() {
        let decide = 0;
        let factor = 5;
        let winFactor = 0;
        let win = game.last.win;

        if (game.last._cost) {
            winFactor = win / (game.last._cost);
        }
        else if (game.old && game.old._cost) {
            winFactor = win / (game.old._cost);
        }
        else if (game.old && game.old._cost === 0) {
            winFactor = win / ((game.panel.lines.get()) * game.panel.coins.get());
        }

        for (decide = 0; decide < game.panel.bigwin.breakpoints.length; decide++) {
            if (winFactor < game.panel.bigwin.breakpoints[decide]) {
                break;
            }
        }

        if (decide >= factor) {
            game.fire_holder.addClass('animate');
            game.celebration.addClass('animate');
        }


    }

    function showBonusIntro(duration) {
        game.last.delayWin = true;
        let message = $.div().addClass('false-messages').appendTo(game.pays);

        message.addClass('intro');
        game.sounds.play('konami_bell');

        setTimeout(function () {
            message.attr('class', 'false-messages');
            message.remove();

            game.panel.setWin(game.last.win);

            setTimeout(function () {
                game.last.delayWin = false;
                spinDone();
            }, duration + 100);


        }, duration);

    }

    function showRetriggerBanner(duration) {
        game.last.delayWin = true;
        retriggeredDisplay = true;
        let message = $.div().addClass('false-messages').appendTo(game.pays);
        message.addClass('intro');

        game.sounds.play(['freespin', 'smallTrigger']);

        setTimeout(function () {
            message.attr('class', 'false-messages');
            message.remove();

            game.last.delayWin = false;
            spinDone();
        }, duration);

    }

    function setWilds(reelMatrix) {
        if (!reelMatrix) {
            reelMatrix = game.last.matrix;
        }

        for (let row in game.spindle.reels) {
            let tall = game.spindle.reels[row].window.tall;
            let tallFrame = game.frame.reels[row].tall;
            let topSym = (reelMatrix[row][0] === 0);
            let midSym = (reelMatrix[row][1] === 0);
            let botSym = (reelMatrix[row][2] === 0);

            tall.attr('class', '');

            if (!topSym && !midSym && !botSym) {
                continue;
            }

            if (topSym && !midSym && !botSym) {
                tall.attr('class', 'top show');
                tall.pos = 'top';
            }

            else if (topSym && midSym && !botSym) {
                tall.attr('class', 'topMid show');
                tall.pos = 'topMid';
            }

            else if (!topSym && !midSym && botSym) {
                tall.attr('class', 'bot show');
                tall.pos = 'bot';
            }

            else if (!topSym && midSym && botSym) {
                tall.attr('class', 'botMid show');
                tall.pos = 'botMid';
            }

            else {
                tall.attr('class', 'full show');
                tall.pos = 'full';
            }
        }
    }

    function nudgeReel(reel, time) {
        game.last.shiftDone = true;
        game.last.delayWin = true;

        let currentReel = [];
        let shiftDelay = [];
        let finalDelay = 0;
        let reelsContainingWild = 0;
        let wildSymbol = 0;
        let reelDelay = 600;

        for (let reel = 0; reel < game.last.matrix.length; reel++) {
            frameAnimations.reels[reel].reelPosition = reel;
            if (game.last.matrix[reel].indexOf(wildSymbol) !== -1) {
                reelsContainingWild++;
                if (game.spindle.reels[reel].window.tall.pos !== 'full') {
                    shiftDelay[reel] = reelDelay;
                } else {
                    shiftDelay[reel] = 0;
                    frameAnimations.reels[reel].reelPosition = reel;
                    frameAnimations.reels[reel].shifted = true;
                }
            }
        }

        for (let index = 0; index < 4; index++) {
            if (shiftDelay[index] === reelDelay) {
                shiftDelay[index] = 0;
                break;
            }
        }

        finalDelay = reelsContainingWild * reelDelay;

        for (let reel = 0; reel < game.last.matrix.length; reel++) {
            frameAnimations.reels[reel].reelPosition = reel;

            let tall = game.spindle.reels[reel].window.tall;

            if (tall.hasClass('show')) {
                tall.addClass('showStack');
            }

            game.animationResize(tall);
            (function () {
                setTimeout(function () {
                    if (game.last.shifted && tall.pos !== 'full' && tall.pos !== null) {
                        game.sounds.play('latch');
                    }

                    for (let row = 0; row < game.last.matrix[reel].length; row++) {
                        currentReel[row] = game.last.matrix[reel][row] === 0;
                    }

                    if (currentReel[0] && !currentReel[1]) {
                        game.spindle.reels[reel].addClass('wild-shift-down-2');
                        game.frame.reels[reel].addClass('frame-shift-down-2');
                        game.spindle.reels[reel].symbols[1].attr('class', 'symbol symbol-0');
                        game.spindle.reels[reel].symbols[2].attr('class', 'symbol symbol-0');
                        frameAnimations.reels[reel].shifted = true;
                    } else if (currentReel[0] && currentReel[1] && !currentReel[2]) {
                        game.spindle.reels[reel].addClass('wild-shift-down-1');
                        game.frame.reels[reel].addClass('frame-shift-down-1');
                        game.spindle.reels[reel].symbols[2].attr('class', 'symbol symbol-0');
                        frameAnimations.reels[reel].shifted = true;
                    } else if (!currentReel[0] && currentReel[1] && currentReel[2]) {
                        game.spindle.reels[reel].addClass('wild-shift-up-1');
                        game.frame.reels[reel].addClass('frame-shift-up-1');
                        game.spindle.reels[reel].symbols[3].attr('class', 'symbol symbol-0');
                        frameAnimations.reels[reel].shifted = true;
                    } else if (!currentReel[0] && !currentReel[1] && currentReel[2]) {
                        game.spindle.reels[reel].addClass('wild-shift-up-2');
                        game.frame.reels[reel].addClass('frame-shift-up-2');
                        game.spindle.reels[reel].symbols[3].attr('class', 'symbol symbol-0');
                        game.spindle.reels[reel].symbols[4].attr('class', 'symbol symbol-0');
                        frameAnimations.reels[reel].shifted = true;
                    }
                }, 500);

                setTimeout(function () {
                    for (let row = 0; row < game.last.matrix[reel].length; row++) {

                        if (game.last.matrix[reel][row] === 0) {

                            for (let symbol = 0; symbol < game.last.matrix[reel].length; symbol++) {
                                game.spindle.reels[reel].window.symbols[symbol].attr('class', 'symbol symbol-0');
                                game.frame.reels[reel].symbols[symbol].attr('class', 'symbol symbol-0');
                            }

                            game.spindle.reels[reel].attr('class', 'reel reel-' + reel);
                            game.frame.reels[reel].attr('class', 'reel reel-' + reel);

                            break;
                        }
                    }
                }, 750)

            })(reel);
        }
        setTimeout(function () {
            game.last.shiftDone = true;
            game.freespinFinish = true;

            game.last.delayWin = false;
            spinDone();
        }, 1000);
    }

    function animateWildStack(duration) {
        game.last.delayWin = true;
        game.last.animateReel = true;

        for (let reel = 0; reel < game.last.matrix.length; reel++) {

            if (maxWinLength >= frameAnimations.reels[reel].reelPosition && frameAnimations.reels[reel].shifted === true && !game.last.scatters.win) {
                setTimeout(function () {

                    frameAnimations.removeClass('hide');
                    frameAnimations.reels[reel].addClass('intro');


                    setTimeout(function () {
                        let offsetWidth = frameAnimations.reels[reel].el.offsetWidth;

                        if (typeof stackWidth !== 'undefined' && offsetWidth < stackWidth) {
                            game.frame.reels[col].symbols[row].css("width", stackWidth);
                            offsetWidth = stackWidth;
                        }
                        stackWidth = offsetWidth;

                        frameAnimations.reels[reel].css('width', offsetWidth - 1);
                        frameAnimations.reels[reel].removeClass('intro');

                        void frameAnimations.reels[reel].el.offsetWidth;
                        frameAnimations.reels[reel].addClass('win');

                    }, 500);


                    game.animationResize(frameAnimations.reels[reel]);
                }, duration);
            }
        }
        setTimeout(function () {
            game.last.delayWin = false;
            spinDone();
        }, duration + 500);

    }

    function checkAnimate() {
        for (let reel = 0; reel < game.last.matrix.length; reel++) {
            if (game.feature.active && game.last.win > 0 && maxWinLength >= frameAnimations.reels[reel].reelPosition) {
                return true;
            }
        }

        return false;
    }


    function findMaxWinLength(payArray) {
        maxWinLength = 0;

        for (let pay = 0; pay < payArray.length; pay++) {
            if (payArray[pay][1] > maxWinLength) {
                maxWinLength = payArray[pay][1];
            }
        }
    }

    function lookForFiveWin(add) {
        let lines = game.last.lines;
        let line = 0;
        let _5win = [];
        let temp = 0;
        let glow_delay = 0;
        let toggle_delay = 0;

        let blacklist = [6, 7, 8, 9, 10, 11, 12];
        let passed = false;

        let matrix = game.last.shiftedMatrix ? game.last.shiftedMatrix : game.last.matrix;

        if (game.last.win < game.last._cost * 5) {
            return;
        }
        if (game.old && game.last.win < game.old._cost * 5) {
            return;
        }

        for (line in lines.pays) {
            if (lines.pays[line][1] === 5) {
                // 5win
                temp = game.config.lines.lines[lines.pays[line][0]];

                // check blacklist
                for (let reel in game.frame.reels) {
                    if ((blacklist.indexOf(matrix[reel][temp[reel]]) > -1)) {
                        passed = false;
                        break;
                    }
                    else {
                        passed = true;
                    }
                }

                // show blue frame
                if (passed) {
                    _5win.push(game.config.lines.lines[lines.pays[line][0]]);
                    glow_delay = 4000;
                }
            }
        }

        win_5s = _5win;

        return glow_delay && add;
    }

    function toggleFiveWin(_5win, add) {


        for (let line in _5win) {
            for (let reel in game.frame.reels) {

                if (add) {
                    let offsetWidth = game.frame.reels[reel].symbols[_5win[line][reel]].el.offsetWidth;

                    if (typeof fiveWinSymbolWidth !== 'undefined' && offsetWidth < fiveWinSymbolWidth) {
                        game.frame.reels[reel].symbols[_5win[line][reel]].css('width', fiveWinSymbolWidth);
                        offsetWidth = fiveWinSymbolWidth;
                    }

                    fiveWinSymbolWidth = offsetWidth;
                    game.frame.reels[reel].symbols[_5win[line][reel]].css('width', offsetWidth - 1);

                    game.frame.reels[reel].symbols[_5win[line][reel]].addClass('_5win');
                    game.spindle.reels[reel].window.symbols[_5win[line][reel]].addClass('_5win');
                }
                else {
                    game.frame.reels[reel].symbols[_5win[line][reel]].removeClass('_5win');
                    game.spindle.reels[reel].window.symbols[_5win[line][reel]].removeClass('_5win');
                }
            }
        }
    }

    function displayFiveWin(duration) {

        game.last.fiveWinDisplayed = true;
        game.last.delayWin = true;
        let message = $.div().addClass('false-messages').appendTo(game.pays);
        message.addClass('five-of-kind');

        game.sounds.play('five_win');

        toggleFiveWin(win_5s, true);

        setTimeout(function () {
            message.attr('class', 'false-messages');
            message.remove();

            let level = (game.last.win / game.panel.denom.get()) / game.panel.coins.get();
            let intro_num = 0;

            if (level >= 2000) {
                // decor = 1;
                intro_num = 2;
            }
            else if (level >= 1000) {
                intro_num = 1;
            }
            else if (level >= 700) {
                intro_num = 1;
            }

            game.sounds.play(['win', 'intro' + intro_num]);

            toggleFiveWin(win_5s, false);


        }, duration);

        setTimeout(function () {
            game.last.delayWin = false;
            spinDone();
        }, duration + 1500);

        game.spindle.on('spin', function () {
            message.removeClass('five-of-kind');
        });
    }

    function overrideStack(reelPosition) {
        let symbols = game.spindle.reels[reelPosition].window.symbols;

        for (let symbol = 0; symbol < symbols.length; symbol++) {
            symbols[symbol].attr('class', 'symbol symbol-0');
        }
    }

    function removeReelStacks(reel) {
        if (game.spindle.reels[reel].hasClass('wild-shift-down-1')) {

            game.spindle.reels[reel].removeClass('wild-shift-down-1');
            game.frame.reels[reel].removeClass('frame-shift-down-1');
        }
        else if (game.spindle.reels[reel].hasClass('wild-shift-down-2')) {
            game.spindle.reels[reel].removeClass('wild-shift-down-2');
            game.frame.reels[reel].removeClass('frame-shift-down-2');
        } else if (game.spindle.reels[reel].hasClass('wild-shift-up-2')) {
            game.spindle.reels[reel].removeClass('wild-shift-up-2');
            game.frame.reels[reel].removeClass('frame-shift-up-2');
        } else if (game.spindle.reels[reel].hasClass('wild-shift-up-1')) {
            game.spindle.reels[reel].removeClass('wild-shift-up-1');
            game.frame.reels[reel].removeClass('frame-shift-up-1');
        }

        frameAnimations.addClass('hide');
        frameAnimations.reels[reel].removeClass('win');
    }

    // recover cost
    game.on('ui', function (e) {
        if (!game.last._cost) {
            setTimeout(function () {
                let bet = game.panel.getBet();
                game.last._cost = bet.coins * bet.lines;
            }, 1);
        }
    });

    function playIntro(duration) {
        let level = (game.last.win / game.panel.denom.get()) / game.panel.coins.get();
        let intro_num = 0;

        if (level >= 2000) {
            intro_num = 2;
        }
        else if (level >= 1000) {
            intro_num = 1;
        }
        else if (level >= 700) {
            intro_num = 1;
        }

        game.sounds.play(['win', 'intro' + intro_num]);

        if (intro_num) {
            if (!exclusive_pays) {
                exclusive_pays = true;
                game.pays.show();
            }
        }
        return;
    }

});


/** WEBPACK FOOTER **
 ** ./public-src/game.js
 **/